import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/pandabuy-sheet-ultimate-guide/page";
import BudgetFindsPage from "../pages/pandabuy-sheet-budget-finds/page";
import SneakerGuidePage from "../pages/pandabuy-sheet-sneaker-guide/page";
import StreetwearPage from "../pages/pandabuy-sheet-streetwear-essentials/page";
import TrendingTikTokPage from "../pages/pandabuy-sheet-trending-tiktok/page";
import LuxuryDupesPage from "../pages/pandabuy-sheet-luxury-dupes/page";
import AccessoriesGuidePage from "../pages/pandabuy-sheet-accessories-guide/page";
import SeasonalPicksPage from "../pages/pandabuy-sheet-seasonal-picks/page";
import QualityGuidePage from "../pages/pandabuy-sheet-quality-guide/page";
import BeginnerTipsPage from "../pages/pandabuy-sheet-beginner-tips/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pandabuy-sheet-ultimate-guide",
    element: <ArticlePage />,
  },
  {
    path: "/pandabuy-sheet-budget-finds",
    element: <BudgetFindsPage />,
  },
  {
    path: "/pandabuy-sheet-sneaker-guide",
    element: <SneakerGuidePage />,
  },
  {
    path: "/pandabuy-sheet-streetwear-essentials",
    element: <StreetwearPage />,
  },
  {
    path: "/pandabuy-sheet-trending-tiktok",
    element: <TrendingTikTokPage />,
  },
  {
    path: "/pandabuy-sheet-luxury-dupes",
    element: <LuxuryDupesPage />,
  },
  {
    path: "/pandabuy-sheet-accessories-guide",
    element: <AccessoriesGuidePage />,
  },
  {
    path: "/pandabuy-sheet-seasonal-picks",
    element: <SeasonalPicksPage />,
  },
  {
    path: "/pandabuy-sheet-quality-guide",
    element: <QualityGuidePage />,
  },
  {
    path: "/pandabuy-sheet-beginner-tips",
    element: <BeginnerTipsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;